import { Link } from 'react-router-dom';
import ArticleLayout from './components/ArticleLayout';

export default function VerkauferPage() {
  return (
    <ArticleLayout
      title="OOPBUY Verkäufer finden – So erkennst du zuverlässige Anbieter"
      description="Lerne, wie du die besten und vertrauenswürdigsten OOPBUY Verkäufer findest. Mit Bewertungen, QC-Checks und Community-Feedback zur richtigen Verkäuferauswahl – dein Guide für sichere Kaufentscheidungen."
      heroImage="https://readdy.ai/api/search-image?query=professional%20handshake%20concept%20on%20warm%20beige%20background%20with%20trust%20and%20partnership%20symbols%2C%20soft%20natural%20lighting%2C%20minimalist%20business%20photography%2C%20warm%20neutral%20tones%2C%20European%20corporate%20aesthetic%2C%20reliability%20concept&width=1600&height=600&seq=article-hero-verkaufer&orientation=landscape"
      heroImageAlt="OOPBUY Verkäufer Guide"
      pageUrl="/oopbuy-verkaufer"
      relatedArticles={[
        { title: 'OOPBUY Sicherheit', path: '/oopbuy-sicherheit' },
        { title: 'OOPBUY QC Guide', path: '/oopbuy-qc-guide' },
        { title: 'OOPBUY Spreadsheet Guide', path: '/oopbuy-spreadsheet-guide' },
        { title: 'OOPBUY für Anfänger', path: '/oopbuy-anfaenger' },
      ]}
    >
      <section className="mb-10">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-4">Warum die richtige Verkäuferwahl entscheidend ist</h2>
        <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-4">
          Im <strong>OOPBUY Spreadsheet</strong> ist die Wahl des richtigen Verkäufers einer der wichtigsten Faktoren für ein erfolgreiches Shopping-Erlebnis. Ein guter Verkäufer liefert nicht nur Qualität, sondern auch zuverlässigen Service, gute QC-Bilder und schnellen Versand.
        </p>
      </section>

      <section className="mb-10">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-4">So erkennst du zuverlässige Verkäufer</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
          <div className="p-4 bg-background-100 rounded-lg">
            <h3 className="text-sm font-semibold text-foreground-900 mb-2">Bewertungshistorie prüfen</h3>
            <p className="text-foreground-600 text-xs leading-relaxed">Ein Verkäufer mit vielen positiven Bewertungen über einen längeren Zeitraum ist vertrauenswürdiger als ein neuer Anbieter ohne Historie.</p>
          </div>
          <div className="p-4 bg-background-100 rounded-lg">
            <h3 className="text-sm font-semibold text-foreground-900 mb-2">QC-Qualität bewerten</h3>
            <p className="text-foreground-600 text-xs leading-relaxed">Gute Verkäufer machen klare, detaillierte QC-Fotos. Verschwommene oder wenige Bilder sind ein Warnsignal.</p>
          </div>
          <div className="p-4 bg-background-100 rounded-lg">
            <h3 className="text-sm font-semibold text-foreground-900 mb-2">Antwortzeit testen</h3>
            <p className="text-foreground-600 text-xs leading-relaxed">Zuverlässige Verkäufer antworten schnell und kompetent auf Fragen. Lange Wartezeiten können auf Probleme hindeuten.</p>
          </div>
          <div className="p-4 bg-background-100 rounded-lg">
            <h3 className="text-sm font-semibold text-foreground-900 mb-2">Community-Feedback nutzen</h3>
            <p className="text-foreground-600 text-xs leading-relaxed">Die OOPBUY Community teilt regelmäßig Erfahrungen mit verschiedenen Verkäufern. Diese Informationen sind Gold wert.</p>
          </div>
        </div>
      </section>

      <section className="mb-10">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-4">Rote Flaggen bei Verkäufern</h2>
        <div className="space-y-2">
          {['Keine oder sehr wenige Bewertungen', 'Verweigerung von QC-Bildern', 'Ungewöhnlich niedrige Preise im Vergleich zum Markt', 'Keine oder unklare Rückgaberichtlinien', 'Schlechte Kommunikation oder ausweichende Antworten'].map((flag, i) => (
            <div key={i} className="flex items-center gap-3 p-2.5 bg-red-50/60 rounded-lg">
              <span className="w-4 h-4 flex-shrink-0 flex items-center justify-center"><i className="ri-close-circle-line text-red-500 text-xs"></i></span>
              <p className="text-foreground-700 text-xs">{flag}</p>
            </div>
          ))}
        </div>
      </section>
    </ArticleLayout>
  );
}